module.exports = __webpack_public_path__ + "img/3_5_freespin_20_line.bc0e449b.png";